import { gql } from "@apollo/client";

export const UPLOAD_FILES = gql`
  mutation UploadFiles($input: [UploadInput!]!) {
    UploadFiles(input: $input) {
      items {
        name
        full_path
      }
    }
  }
`;
